<template>
  <div class="login-code" >
    <h4 class="demonstration">手机扫码，安全登录</h4>
    <div class="scan-box scan-login"  v-if="getScanCode(6002) || getScanCode(6001)">
      <div class="code-box code">
        <el-image v-loading="loading" :src="url" fit="cover"> </el-image>
        <div class="code-fail" v-if="getScanCode(6001)">
            <h3>二维码失效</h3>
            <el-button @click="getCode" size="mini" type="danger" > 刷新</el-button>
        </div>
      </div>

      <el-image
        :src="scan"
        style="width: 24px; height: 23px"
        fit="cover"
      ></el-image>
    </div>
    <div class="scan-box  scan-success" v-else>
      <el-image :src="success" class="code-success" fit="cover"> </el-image>
      <h4>扫描成功!</h4>
      <h5>请在手机上根据提示确认登录</h5>
      <div v-if="getScanCode(0)" >loading...</div>
    </div>

    <div class="goPages">
      <span @click="goToResetpwd">忘记密码</span>
      <span @click="goToRegister">新用户注册</span>
    </div>
  </div>
</template>
<script>
const scan = require("@/assets/images/login/scan.svg");
const success = require("@/assets/images/login/success.svg");

import * as loginApi from "@/util/api";
import loginMixins from "../mixins";
import { setToken,removeToken } from "@/util/auth";
import { clearSessLocal } from "@/util";

//   import reg from '@/util/pattern'
export default {
  data() {
    return {
      scanCode:6002,

      scan,
      success,
      url: "",
      loading: false,
      verify: "",
      timer: "",
    };
  },
  mixins: [loginMixins],
 computed:{
    getScanCode(){
      return function(val){
            return this.scanCode==val
      }
    }
  },
  methods: {
    initWebSocket() {
      // 断开重连机制,尝试发送消息,捕获异常发生时重连
      this.timer = setInterval(() => {
        try {
          this.connection();
        } catch (err) {
          console.log("断线了: " + err);
        }
      }, 1000);
    },
    //获取登录二维码
    async getCode() {
      console.log("---------");
      this.loading = true;
      const code = await loginApi.getLoginCode();
      console.log(code);
      if (code.success) {
        this.loading = false;
        this.url = code.data.qrCode;
        this.qrVerify = code.data.qrVerify;
        this.initWebSocket();
        // this.connection(code.data.qrVerify);
      } else {
        this.url = "";
        this.loading = false;
      }
    },
    async connection() {
      let data = await loginApi.getLogintatus(this.qrVerify);
      console.log(data);
      this.scanCode=data.code;
      if (data.success) {
         clearInterval(this.timer);
         this.scanCode=0;
         this.loginHandle();
      }
      if( data.code==6001){
          clearInterval(this.timer);
      }
      if(data.code==6005){
          clearInterval(this.timer);
          this.scanCode=6002;
          this.getCode();
      }
    },
    async loginHandle(){
      this.loading = true;
      const params = new FormData();
       params.append("grant_type", "qr");
      params.append("qrVerify", this.qrVerify);
      let login_data=await loginApi.login(params);
      if(login_data.success){
        setToken(login_data.data.accessToken, login_data.data.tokenType);
        const user_info = await loginApi.getCurUser();
        if(user_info.success){
           console.log(login_data);
          let loginInfo=await loginApi.pushLoginInfo(params);
          console.log('logininfo',loginInfo);
          if(!loginInfo.data){
               removeToken(); // 清空token
               clearSessLocal(true, true); // 清空sess local
               return;
          }
          if (user_info.code === 0 && user_info.data.uid) {
            this.$store.commit("setUserInfo", user_info.data);
            const geek_info = await loginApi.getSystemId();
            if (geek_info.code === 0) {
               this.$store.commit("setCurrentSystemId", user_info.data.id);
              const fromUrl = this.$route.query.fromUrl || "";

                  if (fromUrl && fromUrl.indexOf("http") !== -1) {
                window.location.href = fromUrl;
              } else {
                const codes = user_info.data.roleRefDtoList.map(
                  (role) => role.code
                );
                if (
                  codes.indexOf("web-consumer-center_admin") >= 0 ||
                  codes.indexOf("web-consumer-center_engineer") >= 0
                ) {
                  window.location.href = "/web-consumer-center";
                } else if (codes.indexOf("web-admin_register-user") >= 0) {
                  this.$message("注册用户请在APP登录");
                } else {
                  window.location.href = "/web-admin";
                }
              }
            }
          }
        }else{
           this.loading = false;
        }
      }else{
           this.loading = false;

      }
    }
  },
  activated() {
    this.getCode();
    // this.initWebSocket();
  },
  mounted() {
    this.getCode();
  },
  beforeDestroy: function () {
    // 页面离开时断开连接,清除定时器
    clearInterval(this.timer);
  },
};
</script>
<style scoped  lang="less">
.login-code {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 20px 0 20px;
  .scan-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 50px;
  }
  .code {
    width: 142px;
    height: 142px;
    margin: 10px 0 20px 0;
  }
  .code-box {
    position: relative;
  }
  .scan-login {
    .code-fail {
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(255, 255, 255, 0.7);
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content:center;
      h3{
        padding-bottom: 10px;
      }
    }
  }

  .scan-success {
    .code-success {
      padding-top: 49px;
      width: 40px;
      height: 40px;
    }
    h4 {
      color: #b03b30;
      padding: 28px 0 17px 0;
    }
    h5 {
      padding-bottom: 30px;
    }
  }
  .goPages {
    color: #999;
    > span {
      cursor: pointer;
      padding-left: 18px;
    }
  }
}
</style>